/**
 * DemoLoginPage — "Bepul boshlash" → demo hisobga AVTOMATIK kirish.
 *
 * Demo do'kon (RLS bilan izolyatsiya qilingan, namuna ma'lumotlar bilan) —
 * foydalanuvchi haqiqiy do'konlardan butunlay ajratilgan demo'ni sinab ko'radi.
 * Hech qanday parol kiritmasdan: shu sahifa demo admin sifatida login qiladi
 * (oddiy /auth/login orqali — yangi auth surface ochmaydi) va dashboard'ga
 * yo'naltiradi.
 */
import { Loader2, Sparkles } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { Navigate } from 'react-router';

import { useIsAuthenticated, useLogin } from '@/features/auth/auth.hooks';

export function DemoLoginPage(): React.ReactElement {
  const isAuthenticated = useIsAuthenticated();
  const loginMutation = useLogin();
  const started = useRef(false);

  useEffect(() => {
    if (started.current || isAuthenticated) return;
    started.current = true;
    loginMutation.mutate({ username: 'demo', password: 'demo2026' });
    // Faqat mount'da bir marta — `started` ref bir martalik kafolat beradi.
  }, [isAuthenticated, loginMutation]);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-background px-6 text-center">
      <div className="flex size-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
        <Sparkles className="size-8" aria-hidden />
      </div>
      <div className="space-y-1.5">
        <h1 className="text-xl font-bold">Demo rejim yuklanmoqda…</h1>
        <p className="max-w-xs text-sm text-muted-foreground">
          Namuna ma&apos;lumotlar bilan AvtoFix POS&apos;ni to&apos;liq sinab ko&apos;rasiz —
          haqiqiy do&apos;konlardan ajratilgan.
        </p>
      </div>
      {loginMutation.isError ? (
        <p className="text-sm font-medium text-destructive">
          Demo hozircha mavjud emas. Birozdan keyin urinib ko&apos;ring.
        </p>
      ) : (
        <Loader2 className="size-6 animate-spin text-primary" aria-label="Yuklanmoqda" />
      )}
    </div>
  );
}
